// Functions
import VerifyToken from "../../config/verifyToken";
// Components
import Header from "../../components/header";
import { Main } from "../generalStyle";
import StickyLogo from "../../components/stickyLogo";
import Settings from "../../components/settings";

const SettingsView = () => (
  <>
    {VerifyToken()}
    <Header />
    <Main>
      <StickyLogo />
      <Settings />
    </Main>
  </>
);

export default SettingsView;
